module.exports = __webpack_public_path__ + "static/img/bg02.fc8891d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg02.png
// module id = Y18U
// module chunks = 2